import { ModalName } from '@/constants/modals';
import { WorkerContactType } from '@/modules/companyNeed/types';

import type { SaveLastContactPayload } from '@/components/modal/Profile/lastContact/types';
import type { WorkerContact } from '@/modules/companyNeed/types';

import { useModalStore } from '@/dsComponents/modals/modalStore';

import {
	ContactType,
	LastContactMode,
} from '@/components/modal/Profile/lastContact/types';

interface OpenLastContactModalBaseOptions {
	workerIds: string[];
	title?: string;
	onSuccess?: (payload?: SaveLastContactPayload) => void | Promise<void>;
	onCancel?: () => void;
}

interface OpenLastContactModalProfileOptions
	extends OpenLastContactModalBaseOptions {
	mode: LastContactMode.PROFILE;
}

interface OpenLastContactModalCompanyNeedOptions
	extends OpenLastContactModalBaseOptions {
	mode: LastContactMode.COMPANY_NEED;
	companyNeedId: string;
	companyNeedCreatedAt?: string;
}

const CONTACT_TYPE_TO_WORKER_CONTACT_TYPE: Record<
	ContactType,
	WorkerContactType
> = {
	[ContactType.CALL]: WorkerContactType.PHONE,
	[ContactType.VOICE_MESSAGE]: WorkerContactType.VOICE_MESSAGE,
	[ContactType.SMS]: WorkerContactType.SMS,
	[ContactType.EMAIL]: WorkerContactType.EMAIL,
	[ContactType.AGENCY_VISIT]: WorkerContactType.AGENCY_VISIT,
};

export const mapSaveLastContactPayloadToWorkerContact = (
	payload: SaveLastContactPayload
): WorkerContact => ({
	type: CONTACT_TYPE_TO_WORKER_CONTACT_TYPE[payload.contactType],
	date: payload.contactedAt.toISOString(),
});

const openLastContactModal = (
	options:
		| OpenLastContactModalProfileOptions
		| OpenLastContactModalCompanyNeedOptions
) => {
	const modalStore = useModalStore();

	modalStore.actions.open(ModalName.LastContactModal, {
		open: true,
		workerIds: options.workerIds,
		mode: options.mode,
		companyNeedId:
			options.mode === LastContactMode.COMPANY_NEED
				? options.companyNeedId
				: undefined,
		companyNeedCreatedAt:
			options.mode === LastContactMode.COMPANY_NEED
				? options.companyNeedCreatedAt
				: undefined,
		title: options.title,
		onSuccess: options.onSuccess,
		onCancel: options.onCancel,
	});
};

export const openLastContactModalForProfile = (
	options: OpenLastContactModalBaseOptions
) => {
	return openLastContactModal({
		...options,
		mode: LastContactMode.PROFILE,
	});
};

export const openLastContactModalForCompanyNeed = (
	options: OpenLastContactModalBaseOptions & {
		companyNeedId: string;
		companyNeedCreatedAt?: string;
	}
) => {
	return openLastContactModal({
		...options,
		mode: LastContactMode.COMPANY_NEED,
	});
};
